import { EMastraAgentId, zSchema } from "@zeal/common";

export const getAiConversationMessagesRequestSchema = zSchema.object({
  conversationId: zSchema.string().min(1),
  companyId: zSchema.string().min(1),
  userId: zSchema.string().min(1),
});

export type TGetAiConversationMessagesRequestSchema = zSchema.infer<
  typeof getAiConversationMessagesRequestSchema
>;

export const aiConversationMessageSchema = zSchema.object({
  role: zSchema.string(),
  content: zSchema.string(),
  rawContent: zSchema.unknown().optional(),
  metadata: zSchema.record(zSchema.string(), zSchema.unknown()).optional(),
});

export type TAiConversationMessage = zSchema.infer<
  typeof aiConversationMessageSchema
>;

export const getAiConversationMessagesResponseSchema = zSchema.object({
  companyId: zSchema.string(),
  conversationId: zSchema.string(),
  messages: zSchema.array(aiConversationMessageSchema),
  streamAgentId: zSchema.nativeEnum(EMastraAgentId).optional(),
});

export type TGetAiConversationMessagesResponseSchema = zSchema.infer<
  typeof getAiConversationMessagesResponseSchema
>;
